export type Phone = {
	prefix: string
	countryIso2: string
	number: string
}

export type CommercialInfo = {
	lifeCycleStatus?: string
	bestAffinityStore?: string
	customerRFMSegment?: string
	valPlusSize?: string
	firstPurchaseDate?: string
	lastMailOpenDate?: string
	lastMonthRFM?: string
	lastOnlinePurchaseDate?: string
	lastPurchaseDate?: string
	lastPurchaseHOME?: string
	lastPurchaseKIDS?: string
	lastPurchaseMAN?: string
	lastPurchaseOUTLET?: string
	lastPurchaseSHE?: string
	lastPurchaseVIOLETA?: string
	lastSeasonTOP?: string
	lastStorePurchaseDate?: string
	purchasingPostalCode?: string
	CLTV?: number
}

export enum TierLevels {
	'TIER_1' = 1,
	'TIER_2' = 2,
	'TIER_3' = 3,
}

export type TiersStructure = {
	level: TierLevels
	name: string
	threshold: number
}

export type Tier = {
	tier: TierLevels
	tierName: string
	tiersStructure: TiersStructure[]
}

export enum SubscriptionLines {
	HE = 'HE',
	SHE = 'SHE',
	KIDS = 'KIDS',
	HOME = 'HOME',
	OUTLET = 'OUTLET',
	LEGACY_UNKNOWN = 'LEGACY_UNKNOWN',
}

export enum UserContactChannels {
	EMAIL = 'EMAIL',
	SMS = 'SMS',
	POST = 'POST',
}

export enum Gender {
	FEMALE = 'FEMALE',
	MALE = 'MALE',
	NON_BINARY = 'NON_BINARY',
	DONT_ANSWER = 'DONT_ANSWER',
}

export type UserContactability = {
	isContactable: boolean
	subscriptions: {
		lines: SubscriptionLines[]
		channels: UserContactChannels[]
		communicationLanguage: string
	}
}

export type UserLoyalty = {
	isLoyalty?: boolean
	likes?: {
		expiringMonth?: number
		total?: number
		available?: number
		expiringMonthAsMoney?: number
		totalAsMoney?: number
		availableAsMoney?: number
		redeemThreshold?: number
		redeemThresholdAsMoney?: number
		currency?: string
		tier?: Tier
		annualNetExpense?: number
	}
	firstDiscount?: {
		active?: boolean
		value?: number
	}
}

export type CountryInfo = {
	iso2: string // "es",
	mangoIso: string // "ES1",
	mangoId: string // "021",
	'iso3166-2': string // "ES-CA"
}

export type ExternalIdentifiers = {
	consumerRepository: {
		externalId: string
		emailContactId: string
		mobileContactId: string
		addressContactId: string
	}
}

export type LegacyInfo = {
	legacyId: string
	legacyAppToken: string
}

export type User = {
	readonly id: string
	readonly isLoggedIn: true
	readonly birthDate?: string
	readonly email: string
	readonly hashedEmail: string
	readonly firstName?: string
	readonly lastName?: string
	readonly gender?: Gender
	readonly phoneInfo: Phone
	readonly confidenceLevel?: number
	readonly addresses?: Object[]
	readonly countryInfo: CountryInfo
	readonly externalIdentifiers: ExternalIdentifiers
	readonly contactability: UserContactability
	readonly legacyInfo?: LegacyInfo
	readonly creationDate: string
	readonly updateDate?: string
	readonly deleteDate?: string
	readonly commercialInfo: CommercialInfo
	readonly loyalty?: UserLoyalty
}

export type UserResponse = {
	oAuth: {
		access: string
		refresh: string
	}
} & User
